
/* Checkbox set object proxy.
11/11/2020 Created RLB

Requires checkbox library symbol to be instantiated on stage.
	selected : boolean. 
	labelSide: string.   "left", "right"
	labelFont: string. e.g. Any valid value for the CSS font attribute is acceptable (ex. "bold 36px Arial").   https://createjs.com/docs/easeljs/classes/Text.html
	labelColor: string		Whatever is accepted by UtilSP.c2rgba
	labelText: string	

Throws CLICKEDCHECKBOX'
*/
import AnimateProxyBase from "SATPROF_LIBRARY/DropinSupervisor/animate-proxys/animate-proxy-base";
import AnimateButtonProxy from "SATPROF_LIBRARY/DropinSupervisor/animate-proxys/animate-button-proxy";
import TimingInfo from "SATPROF_LIBRARY/DropinSupervisor/timing-info";
import AnimateRenderSpace from "SATPROF_LIBRARY/DropinSupervisor/render-spaces/animate-render-space";
import UtilSP from "SATPROF_UTILS/UtilSP"; 
import { StringKeyframeTrack, AudioAnalyser } from "three";

export default class Checkbox extends AnimateProxyBase{
 
	private _selected:boolean = false;

	// Settable properties:
	private _text:createjs.Text;
	private _labelText:string;
	private _labelFont:string = "16px Arial";
	private _labelSide:string = "right;"
	private _labelColor:string = "#000000";
	public name:string;
	private targetFill:createjs.Shape;
	private _fillColor = "white";

    onFrameZero(){
        //console.log("In Checkbox.onFrameZero()");
        super.onFrameZero();
        const animate_rs:AnimateRenderSpace = this.extraData.animateSpace;
        //this.stageSymbol.outline_mc.rotation = 20;
        this.initialize();

    }
	public initialize(){
		let i:number = 0;
		this._text = new createjs.Text;
		this._labelText = "label";
		this.stageSymbol.target.addEventListener("click", this.clickHandler.bind(this));
		this.stageSymbol.addChild(this._text);
		this._text.x = 0;
		this._text.y = 0;

		this.targetFill = new createjs.Shape();

		this.stageSymbol.target.addChild(this.targetFill);

		this.fillColor = "white"; // Use setter
		this.selected = false; // Use setter
		this.updateLabel();
    }  
    onRequestAnimFrame(timingInfo : TimingInfo) {
        // Do every frame
	}  
	private clickHandler(evt:any){

		let bname:string = evt.target.parent.name;
		let i:number = Number(bname.substring(2));
		this.selected = !this.selected; // use setter. It will NOT throw the CLICKEDCHECKBOX event.
		///console.log("in clickHandler");
		const event = new CustomEvent('CLICKEDCHECKBOX', { detail:{name:this.name} });
		window.dispatchEvent(event);		
	}
	private updateLabel(){
		//console.log("In updateLabel, this._labelSide = "+this._labelSide);

		this._text.y = 0;
		this._text.textBaseline = "middle";
		this._text.color = UtilSP.c2rgba(this._labelColor);
		this._text.font = this._labelFont;
		this._text.text = this._labelText;
		if (this._labelSide == "left"){
			this._text.x = -10;
			this._text.textAlign = "right";
		} else {
			// Assume right side
			this._text.x = 10;
			this._text.textAlign = "left";
		}
	}

	//-----------------------------------------------------------------------------
	public set selected(val:boolean){
		this._selected = val;
		this.stageSymbol.checkmark.visible = val;
		// Don't throw a clicked event just because this got called by someone.
		//console.log("In set selected = "+val+". Dispatching event CLICKEDCHECKBOX");
		//const event = new CustomEvent('CLICKEDCHECKBOX', { detail:{name:this.name} });
		//window.dispatchEvent(event);

	}
	public get selected():boolean{
		return this._selected;
	}	
	// Setters and getters
	public set labelSide(val:string){
		this._labelSide = val;
	}
	public get labelSide():string{
		return this._labelSide;
	}	
	public set labelFont(val:string){
		this._labelFont = val;
		this.updateLabel();
	}
	public get labelFont(){
		return this._labelFont;
	}	
	public set labelColor(val:string){
		this._labelColor = val;
		this.updateLabel();
	}
	public get labelColor(){
		return this._labelColor;
	}	
	public set labelText(str:string){
		this._labelText = str;
		this.updateLabel();
	}
	public get labelText():string{
		return this._labelText;
	}
	public set fillColor(val:string){
		this._fillColor = val;
		this.targetFill.graphics.clear();
		this.targetFill.graphics.setStrokeStyle(2);
		this.targetFill.graphics.beginStroke(UtilSP.c2rgba("#636363"));
		this.targetFill.graphics.beginFill(UtilSP.c2rgba(this._fillColor));
		this.targetFill.graphics.drawRect(-7,-7,14,14);
	}
	public get fillColor():string{
		return this._fillColor;
	}		
}

